import { ParamMap, ActivatedRoute, Router } from '@angular/router';
import { Component } from '@angular/core';
import { palexy } from '../../generated/bundle';
import { QcService } from '../qc.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StoreService } from '../../common/store.service';
import { StoreConfigService } from '../../task/storeconfig.service';
import { MatDialog } from '@angular/material/dialog';
import { AccuracyResultDetailDialogComponent } from './accuracy-detail-dialog/accuracy-result-detail-dialog.component';

@Component({
  selector: 'app-qc-file-detail',
  templateUrl: './qc-file-detail.component.html',
  styleUrls: ['./qc-file-detail.component.css']
})
export class QcFileDetailComponent {

  qcFile: palexy.sherlock.v1.IQcFile;
  store: palexy.streaming.v1.Store;
  accuracyResults: palexy.sherlock.v1.IAccuracyResult[] = [];
  accuracyTypeEnum = palexy.sherlock.v1.AccuracyType;
  qcType = palexy.sherlock.v1.QcFile.QcType;
  lowAccuracyResults = new Set<palexy.sherlock.v1.IAccuracyResult>();
  visitMatchRows: VisitMatchRow[] = [];
  isLoading = false;

  readonly ACCURACY_TYPE_ORDER: palexy.sherlock.v1.AccuracyType[] = [
    palexy.sherlock.v1.AccuracyType.VISITOR_COUNTING_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.INTERACTION_RATE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.AGE_DISTRIBUTION_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.GENDER_DISTRIBUTION_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.DWELL_TIME_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.GREETING_RATE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.TIME_TO_FIRST_GREETING_DISTRIBUTION_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.VISITOR_COUNTING_FOR_1H_SLOT,

    palexy.sherlock.v1.AccuracyType.FNB_IN_QUEUE_VISITOR_COUNTING_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_AVERAGE_QUEUE_LENGTH_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_AVERAGE_QUEUE_TIME_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_QUEUE_TIME_DISTRIBUTION_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_AVERAGE_TRANSACTION_TIME_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_TRANSACTION_TIME_DISTRIBUTION_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_AVERAGE_ORDER_PREPARATION_TIME_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_ORDER_PREPARATION_TIME_DISTRIBUTION_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_AVERAGE_TOTAL_SERVICE_TIME_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_TOTAL_SERVICE_TIME_DISTRIBUTION_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_SAMPLE_RATE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_IN_QUEUE_VISITOR_COUNTING_FOR_1H_SLOT,

    palexy.sherlock.v1.AccuracyType.FNB_VISIT_PRECISION_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_VISIT_FALSE_DISCOVERY_RATE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_VISIT_RECALL_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_VISIT_MISS_RATE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_QUEUE_TIME_MAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_QUEUE_TIME_WMAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_QUEUE_TIME_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_QUEUE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TRANSACTION_TIME_MAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TRANSACTION_TIME_WMAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TRANSACTION_TIME_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TRANSACTION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_ORDER_PREPARATION_TIME_MAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_ORDER_PREPARATION_TIME_WMAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_ORDER_PREPARATION_TIME_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_ORDER_PREPARATION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TOTAL_SERVICE_TIME_MAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TOTAL_SERVICE_TIME_WMAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TOTAL_SERVICE_TIME_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TOTAL_SERVICE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY,
  ];

  // Error rates: near 0 is good, and bias can be negative, so these are flagged above 20% either way.
  readonly LOWER_IS_BETTER_ACCURACY_TYPES: palexy.sherlock.v1.AccuracyType[] = [
    palexy.sherlock.v1.AccuracyType.FNB_VISIT_FALSE_DISCOVERY_RATE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_VISIT_MISS_RATE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_QUEUE_TIME_MAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_QUEUE_TIME_WMAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_QUEUE_TIME_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_QUEUE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TRANSACTION_TIME_MAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TRANSACTION_TIME_WMAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TRANSACTION_TIME_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TRANSACTION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_ORDER_PREPARATION_TIME_MAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_ORDER_PREPARATION_TIME_WMAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_ORDER_PREPARATION_TIME_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_ORDER_PREPARATION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TOTAL_SERVICE_TIME_MAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TOTAL_SERVICE_TIME_WMAPE_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TOTAL_SERVICE_TIME_BIAS_FOR_WHOLE_DAY,
    palexy.sherlock.v1.AccuracyType.FNB_MATCHED_TOTAL_SERVICE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY,
  ];

  readonly VISIT_TIME_HEADERS = ['Start Queue', 'Start Transaction', 'End Transaction', 'Pickup'];
  readonly VISIT_DURATION_HEADERS = ['Queue Time', 'Transaction Time', 'Order Preparation Time', 'Total Service Time'];

  readonly HOURLY_ACCURACY_TYPES: palexy.sherlock.v1.AccuracyType[] = [
    palexy.sherlock.v1.AccuracyType.VISITOR_COUNTING_FOR_1H_SLOT,
    palexy.sherlock.v1.AccuracyType.GROUP_COUNTING_FOR_1H_SLOT,
  ];


  constructor(
    private router: Router,
    storeService: StoreService,
    private qcService: QcService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private dialog: MatDialog,
  ) {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.isLoading = true;
      const id = params.get('qcFileId');
      this.qcService.getQcFileById(id).subscribe(response => {
        this.qcFile = response.qcFile;
        storeService.getStore(this.qcFile.storeId).subscribe(response => {
          this.store = response;
        });
        this.visitMatchRows = [];
        if (this.qcFile.qcType == this.qcType.ICA_FNB_QUEUE_METRIC_PER_PERSON) {
          this.qcService.getFnbVisitMatches(id).subscribe(response => {
            this.visitMatchRows = response.matches.map(toVisitMatchRow);
          });
        }
      });

      this.qcService.getAccuracyResults(id).subscribe(response => {
        this.accuracyResults = response.results.filter(accuracyResult => !accuracyResult.experimentProgrammingName);
        this.accuracyResults.sort((a, b) => {
          if (a.accuracyType != b.accuracyType) {
            const aIndex = this.ACCURACY_TYPE_ORDER.indexOf(a.accuracyType);
            const bIndex = this.ACCURACY_TYPE_ORDER.indexOf(b.accuracyType);
            if (aIndex == -1) {
              return 1;
            }
            if (bIndex == -1) {
              return -1;
            }
            return aIndex - bIndex;
          }
          if (a.sectionName != b.sectionName) {
            return a.sectionName.localeCompare(b.sectionName);
          }
          return a.hourSlot - b.hourSlot;
        });
        this.lowAccuracyResults = new Set(this.accuracyResults.filter(r =>
          this.LOWER_IS_BETTER_ACCURACY_TYPES.includes(r.accuracyType)
            ? Math.abs(r.accuracyNumber) > 0.2
            : r.accuracyNumber < 0.8));
        this.isLoading = false;
      });
    });
  }

  deleteQcFile() {
    if(confirm('Are you sure you want to delete this QC File?')) {
      this.qcService.deleteQcFileById(this.qcFile.id).subscribe(response => {
        this.snackBar.open('Delete succesfully!', null, { duration: 3000,  panelClass: ['snackbar-style']});
        this.router.navigate(['qcfiles']);
      });
    }
  }

  openAccuracyResultDetailDialog(accuracyResult: palexy.sherlock.v1.IAccuracyResult) {
    if (accuracyResult.additionalData.length == 0) {
      return;
    }
    this.dialog.open(AccuracyResultDetailDialogComponent, {
      width: '80vw',
      height: '80vh',
      maxWidth: '80vw',
      maxHeight: '80vh',
      autoFocus: false,
      data: accuracyResult,
    });
  }

}



interface VisitMatchRow {
  state: string;
  stateClass: string;
  systemPersonId: string;
  qcVisitorId: string;
  qcGroupId: string;
  // Same order as VISIT_TIME_HEADERS and VISIT_DURATION_HEADERS.
  times: { system: string, qc: string }[];
  durations: { system: string, qc: string, error: string }[];
}

function toVisitMatchRow(match: palexy.sherlock.v1.IFnbVisitMatch): VisitMatchRow {
  const state = palexy.sherlock.v1.FnbVisitMatch.State[match.state];
  return {
    state,
    stateClass: state.toLowerCase().replace(/_/g, '-'),
    systemPersonId: match.systemPersonId,
    qcVisitorId: match.qcVisitorId,
    qcGroupId: match.qcGroupId,
    times: [
      { system: match.systemStartQueueTime, qc: range(match.qcMinStartQueueTime, match.qcMaxStartQueueTime) },
      { system: match.systemStartTransactionTime, qc: match.qcStartTransactionTime },
      { system: match.systemEndTransactionTime, qc: range(match.qcMinEndTransactionTime, match.qcMaxEndTransactionTime) },
      { system: match.systemPickupTime, qc: match.qcPickupTime },
    ],
    durations: [match.queueTime, match.transactionTime, match.orderPreparationTime, match.totalServiceTime]
      .map(toDuration),
  };
}

function range(min: string, max: string): string {
  return min == max ? min : `${min} - ${max}`;
}

// Error is measured as the backend does: against the nearer edge of the QC range, 0 inside it.
function toDuration(d: palexy.sherlock.v1.IFnbVisitDuration) {
  const system = d.hasSystem ? `${d.systemSeconds}s` : '';
  const qc = !d.hasQc ? '' : d.qcMinSeconds == d.qcMaxSeconds ? `${d.qcMinSeconds}s` : `${d.qcMinSeconds}-${d.qcMaxSeconds}s`;
  let error = '';
  if (d.hasSystem && d.hasQc) {
    const reference = Math.max(d.qcMinSeconds, Math.min(d.systemSeconds, d.qcMaxSeconds));
    const diff = d.systemSeconds - reference;
    error = diff > 0 ? `+${diff}s` : `${diff}s`;
  }
  return { system, qc, error };
}
